export default __webpack_public_path__ + "static/media/logo_white.7ea7fa5e.svg";